import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center text-xl"
}
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = {
  key: 0,
  class: "row g-3"
}
const _hoisted_4 = { class: "col-12 col-md-6" }
const _hoisted_5 = { class: "mb-3 d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted me-2" }, "Tên:", -1)
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = { class: "mb-3 d-flex align-items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted me-2" }, "Mã:", -1)
const _hoisted_10 = { class: "fw-bold" }
const _hoisted_11 = { class: "mb-3 d-flex align-items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted me-2" }, "Ghi chú:", -1)
const _hoisted_13 = { class: "fw-bold" }
const _hoisted_14 = { class: "col-12 col-md-6" }
const _hoisted_15 = { class: "mb-3 d-flex align-items-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted me-2" }, "ID:", -1)
const _hoisted_17 = { class: "fw-bold" }
const _hoisted_18 = { class: "mb-3 d-flex align-items-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted me-2" }, "Số hiệu:", -1)
const _hoisted_20 = { class: "fw-bold" }
const _hoisted_21 = {
  key: 0,
  class: "mb-3 d-flex align-items-center"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted me-2" }, "Nhóm toa xe:", -1)
const _hoisted_23 = {
  class: "inline-flex gap-2",
  role: "group"
}

import { PropType, ref, watch } from 'vue';
import { IToaXeResponseBase } from '@/core/interfaces/ApiResponses';
import { DetailModalShell } from '@/components/shared/modal';
import ToaXeService from '@/core/services/ToaXe.service';
import { useLoading } from '@/core/hooks/use-loading';
import { swalErrNotification, swalNotification } from '@/core/helpers/utils';
import { useButtonCustom } from '@/core/hooks/use-button-custom';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
import ConfirmationDialog from '@/components/confirmation-dialog/ConfirmationDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ToaXeDetailModal',
  props: {
  id: {
    type: Number as PropType<number | undefined>,
    default: undefined,
  },
  showDeleteToaXeButton: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const props = __props;

const toaXeDetail = ref<IToaXeResponseBase | null>(null);

const { startLoading, endLoading } = useLoading();

const { ButtonsType, ButtonTypeColors } = useButtonCustom();

const removeItemDialogDisplay = ref(false);

const fetchToaXeDetail = async () => {
  if (!props.id) return;

  try {
    startLoading();

    const {
      data: { data },
    } = await ToaXeService.get(props.id);

    toaXeDetail.value = data;

    endLoading();
  } catch (e) {
    endLoading();

    await swalErrNotification(e, 'Có lỗi xảy ra khi lấy thông tin toa xe');
  }
};

watch(
  () => props.id,
  () => {
    fetchToaXeDetail();
  }
);

const emit = __emit;

const closeModal = () => {
  toaXeDetail.value = null;

  emit('close');
};

const confirmDelete = async () => {
  if (!props.id) return;

  try {
    await ToaXeService.delete(props.id);

    removeItemDialogDisplay.value = false;

    closeModal();

    await swalNotification('Xóa thành công', 'success');
  } catch (error) {
    closeModal();

    removeItemDialogDisplay.value = false;

    await swalErrNotification(error, 'Có lỗi xảy ra, không thể xóa toa xe này');
  }
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ConfirmationDialog, {
      title: "Xác nhận",
      size: "sm",
      "is-display": removeItemDialogDisplay.value,
      onOnConfirmButtonClick: confirmDelete,
      onOnCloseButtonClick: _cache[0] || (_cache[0] = ($event: any) => (removeItemDialogDisplay.value = false)),
      onOnCloseIconClick: _cache[1] || (_cache[1] = ($event: any) => (removeItemDialogDisplay.value = false))
    }, {
      default: _withCtx(() => [
        (toaXeDetail.value)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_1, [
              _createTextVNode(" Bạn hãy chắc chắn muốn xóa toa xe "),
              _createElementVNode("span", _hoisted_2, _toDisplayString(toaXeDetail.value.ten_toa_xe), 1),
              _createTextVNode("? ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-display"]),
    _createVNode(_unref(DetailModalShell), {
      "is-display": !!toaXeDetail.value,
      title: "Chi tiết toa xe",
      "lottie-topic": "danh-muc-toa-xe",
      onClose: closeModal
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          (__props.showDeleteToaXeButton)
            ? (_openBlock(), _createBlock(ButtonCustom, {
                key: 0,
                "button-type": _unref(ButtonsType).TRASH,
                "color-type": _unref(ButtonTypeColors).DANGER,
                "delay-time": 0,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (removeItemDialogDisplay.value = true))
              }, {
                "button-label": _withCtx(() => [
                  _createTextVNode("Xoá")
                ]),
                _: 1
              }, 8, ["button-type", "color-type"]))
            : _createCommentVNode("", true),
          _createVNode(ButtonCustom, {
            "button-type": _unref(ButtonsType).CANCEL,
            "color-type": _unref(ButtonTypeColors).DANGER,
            "delay-time": 0,
            onClick: closeModal
          }, {
            "button-label": _withCtx(() => [
              _createTextVNode("Đóng")
            ]),
            _: 1
          }, 8, ["button-type", "color-type"])
        ])
      ]),
      default: _withCtx(() => [
        (toaXeDetail.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("span", _hoisted_7, _toDisplayString(toaXeDetail.value.ten_toa_xe), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("span", _hoisted_10, _toDisplayString(toaXeDetail.value.ma_toa_xe), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("span", _hoisted_13, _toDisplayString(toaXeDetail.value.ghi_chu), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("span", _hoisted_17, _toDisplayString(toaXeDetail.value.id), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("span", _hoisted_20, _toDisplayString(toaXeDetail.value.so_hieu), 1)
                ]),
                (toaXeDetail.value.danh_muc_toa_xe?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _hoisted_22,
                      _createVNode(_component_RouterLink, {
                        class: "underline text-primary hover:text-primary fw-bold",
                        to: {
                name: 'chi-tiet-danh-muc-toa-xe',
                params: {
                  id: toaXeDetail.value.danh_muc_toa_xe[0].id,
                },
              }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(toaXeDetail.value.danh_muc_toa_xe[0].ten_danh_muc), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-display"])
  ], 64))
}
}

})